import Slot from './container';

export default Slot;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings_Slot/index.js